import React, { useState } from "react";
import { useGlobalContext } from "../../GlobalContext";
import mutasiTunggakanPdf from "./pdf/mutasitunggakan";

function MutasiTunggakan() {
  const { bulan, api } = useGlobalContext();
  const Tahunaktif = new Date().getFullYear();
  const tahunterakhir = Array.from({ length: 3 }, (_, i) => Tahunaktif - i);

  const [selectedBulan, setSelectedBulan] = useState(0);
  const [selectedYear, setSelectedYear] = useState(tahunterakhir[0]);
  const [loading, setLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const handleSubmit = async () => {
    const bulanNumber = (selectedBulan + 1).toString().padStart(2, "0");
    const periode = `${selectedYear}${bulanNumber}`;
    const namaBulan = bulan[selectedBulan] || "Tidak Diketahui";
    const tahun = selectedYear;

    setLoading(true);
    try {
      const res = await api.get(`/api/tunggakan/${periode}`);

      if (res.status === 404) {
        alert(`Data tunggakan tidak ditemukan untuk ${namaBulan} ${tahun}.`);
        return;
      }

      const data = res.data;

      if (!Array.isArray(data) || data.length === 0) {
        alert(`Data tunggakan tidak tersedia.`);
      } else {
        const periodeLabel = `${namaBulan.toUpperCase()} ${tahun}`;
        mutasiTunggakanPdf(periodeLabel, data);
      }

    } catch (err) {
      console.error("Gagal fetch:", err);
      alert(`Terjadi kesalahan: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleExportExcel = async () => {
    const bulanNumber = (selectedBulan + 1).toString().padStart(2, "0");
    const periode = `${selectedYear}${bulanNumber}`;
    const namaBulan = bulan[selectedBulan] || "Tidak Diketahui";
    const tahun = selectedYear;

    setIsExporting(true);
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/api/exsportexcell/tunggakan/${periode}`, {
        responseType: 'blob',
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });

      const filename = `Tunggakan_${namaBulan}_${tahun}.xlsx`;
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Export Excel error:', err);
      alert('Gagal mengekspor Excel.');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="row">
        <div className="col-md-12">
          <div className="card card-info" style={{ width: "400px" }}>
            <div className="card-header bg-info text-white">
              <h5 className="card-title">Laporan Tunggakan</h5>
            </div>
            <div className="card-body">
              <form className="form-horizontal">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Periode</label>
                  <div className="col-sm-5">
                    <select
                      className="form-control"
                      value={selectedBulan}
                      onChange={(e) => setSelectedBulan(parseInt(e.target.value))}
                    >
                      {bulan.map((item, index) => (
                        <option key={index} value={index}>
                          {item.toUpperCase()}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-sm-4">
                    <select
                      className="form-control"
                      value={selectedYear}
                      onChange={(e) => setSelectedYear(e.target.value)}
                    >
                      {tahunterakhir.map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "Mengambil Data..." : "Cetak"}
              </button>
              <button
                type="button"
                className="btn btn-sm btn-success ml-2"
                onClick={handleExportExcel}
                disabled={isExporting}
              >
                {isExporting ? 'Mengekspor...' : 'Export Excel'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MutasiTunggakan;
